import axios from "axios";
import config from "../config.json";
const token = localStorage.getItem("jwtToken");

export const checkTransactionStatusHelper = (data, path) => {
  let retries = 0;
  const maxRetries = 10; // Stop polling after 10 tries (~30 seconds)

  // console.log("⏳ Checking status...", data);

  return new Promise((resolve, reject) => {
    const interval = setInterval(async () => {
      try {
            const statusConfig = {
              baseURL: config.LOCAL_API_URL,
              headers: {
                Authorization: `Basic ${token}`,
              },
              data,
              method: "post",
              url: path,
            };

          if (++retries >= maxRetries) {
              console.log("⚠️ Stopping polling after max retries.");
              clearInterval(interval);
              reject("You have exceeded time limit")
          }
          // start from here 
          
          const resp = await axios(statusConfig);
          // console.log("result success", resp);
          clearInterval(interval); // Stop polling
          resolve(resp);

      } catch (error) {
          // console.error("❌ Error checking status:", error);
          clearInterval(interval); // Stop polling
          reject(error)
      }
  }, 3000); // Check every 3 seconds
  })
}

export const uniqueArray = (arr, wallet) => {
  const res = Object.values(
    arr.filter(vl => vl.collectionName !== "").reduce((acc, current) => {
      (acc[current.collectionName.trim()] = acc[current.collectionName.trim()] || []).push(
        current
      );
      return acc;
    }, {})
  );

  const Arr = [];
  res.forEach((vl) => {
    if (vl.find(({ accountNumber }) => accountNumber === wallet)) {
      if (vl.some(v1 => v1.isPurchased === 0)) {
        if (vl.find(v2 => v2.IssuerAddr === wallet)) {
          Arr.push(vl.find(({ isPurchased }) => isPurchased === 0));
        } else if (vl.find(v2 => v2.IssuerAddr === null)) {
          Arr.push(vl.find(({ isPurchased }) => isPurchased === 0));
        }
      }
      if (vl.some(v1 => v1.isPurchased === 1)) {
        Arr.push(vl.find((({ isPurchased }) => isPurchased === 1)));
      }
    } else if (vl.some(({ accountNumber }) => accountNumber !== wallet)) {
      if (vl.some(({ isPurchased }) => isPurchased === 0)) {
        Arr.push(vl.find(({ isPurchased }) => isPurchased === 0));
      } else if (vl.some(({ isPurchased }) => isPurchased === 1)) {
        Arr.push(vl.find(({ isPurchased }) => isPurchased === 1));
      }
    }
  });

  // console.log(Arr, "resp in data")

  return Arr.filter(vl => vl);
}

export const replaceHost = (url) => {
  const CID = url.split("/").pop();
  const finalUrl = `${config.ipfs_p}${CID}`;
  return finalUrl
}


export const extractCIDFromURL = (url) => {
  const regex = /ipfs\/([^/]+)/; // Matches the CID part in the URL
  const match = url.match(regex);
  return match ? match[1] : null; // Return CID or null if not found
}


export const checkImageExists = async (cid) => {
  const url = `${config.ipfs_p}${cid}`;
  
  try {
    const response = await fetch(url, { method: 'HEAD' });
    return response.ok;
  } catch (error) {
    console.error('Error checking image:', error);
    return false;
  }
}

const encodeUnicodeToBase64 = (str) => {
  return btoa(unescape(encodeURIComponent(str)));
}

const decodeBase64ToUnicode = (base64) => {
  return decodeURIComponent(escape(atob(base64)));
}

export { encodeUnicodeToBase64, decodeBase64ToUnicode }